import { toast } from "react-toastify"

export const toaster = (type, message) => {
return toast[type](<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{message}</p></p>, {
                position: 'top-right',
                autoClose: 5000,
                closeButton: false,
                theme: 'light'
            })
}